module.exports = new __parcel__URL__("ProgressCirclesNavigation.e2e6ad70.svg").toString();